/* eslint-disable */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { View, Text, Platform, Dimensions, TouchableOpacity } from 'react-native'
import styles from './Styles/AlertMessageStyles'
import Modal from 'react-native-modalbox';
import { Button } from 'native-base';
import TextComponent from './TextComponent'
import I18n from "i18n-js"

export default class AlertMessage extends Component {


  showModal = () => {
    this.refs.modal.open()
  }
  hideModal = () => {
    this.refs.modal.close()
  }
  render() {
/*
<TextComponent
  style={styles.title}
  text={`In order to tag Item, you must `} />
<TextComponent
  style={styles.title}
  text={`configure PayPal.`} />
<TextComponent
  style={styles.title}
  text={` Would you like to do that now?`} />
</View>
*/
    return (
      <Modal
        ref={"modal"}
        style={styles.container}
        position='center'
        backdrop={true}
        onClosed={() => {
        }}
      >
      <View style = {styles.top}>
        <TextComponent
          allowFontScaling={false}
          style={[styles.title, {fontSize: 14}]}
          text={this.props.title} />
      </View>
      <View style={styles.bottom}>
        <TouchableOpacity
          onPress={this.props.yesModal} style={[styles.button]}>
          <TextComponent allowFontScaling={false} text={I18n.t('btn.yes')} styles={styles.buttonText} />
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.button]}
          onPress={() => this.refs.modal.close()}
          style={styles.button}>
          <TextComponent allowFontScaling={false} text={I18n.t('btn.no')} styles={styles.buttonText} />
        </TouchableOpacity>
      </View>

    </Modal>)
  }
}
